import { http } from "api/http";
import { cronHttp } from "api/cronHttp";

const getAdminActivityLog = ({ queryKey }: any) => {
  return http.get("/admin-activity-log", { params: queryKey[1] });
};

const getAdminActivityLogStats = ({ queryKey }: any) => {
  return http.get("/admin-activity-log/stats", { params: queryKey[1] });
};

const exportAdminActivityLog = (params: any) => {
  return cronHttp.post("/admin-activity-log/export", params, { responseType: "blob" });
};

export { getAdminActivityLog, getAdminActivityLogStats, exportAdminActivityLog };
